
import React, { useEffect, useState } from "react";
import {
  Bracket,
  RenderSeedProps,
  RoundProps,
  Seed,
  SeedItem,
  SeedTeam,
} from "react-brackets";
import { Header } from "../../components";
import { useEsportsAPI } from "../../hooks";

export const PlayoffPage = () => {
  const [playoffs, setPlayoffs] = useState<any>({});
  const { getPlayoffs } = useEsportsAPI();

  useEffect(() => {
    getPlayoffs()
      .then((res) => res.data)
      .then((data) => setPlayoffs(data));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getXboxPlayoffData: () => RoundProps[] = () => {
    const xboxPlayoffs = playoffs["Xbox Playoffs"];
    if (xboxPlayoffs !== undefined) {
      const roundTitles = Object.keys(xboxPlayoffs);
      const xboxPlayoffsFormatted: any = roundTitles.map((item) => {
        return { title: item, seeds: [] };
      });
      roundTitles.forEach((title) => {
        const row = xboxPlayoffs[title];
        const formattedRows = row.map((item: any) => {
          const teams = [{ name: item.team1 }, { name: item.team2 || "" }];
          const roundName = item.roundName;
          return { teams, roundName };
        });
        const index = xboxPlayoffsFormatted.findIndex(
          (item: { title: string }) => item.title === title
        );
        xboxPlayoffsFormatted[index].seeds = formattedRows
        // xboxPlayoffsFormatted[title].seeds.push(row)
      });
      return xboxPlayoffsFormatted;
    }
  };

  const getPlaystationPlayoffData: () => RoundProps[] = () => {
    const xboxPlayoffs = playoffs["Playstation Playoffs"];
    if (xboxPlayoffs !== undefined) {
      const roundTitles = Object.keys(xboxPlayoffs);
      const xboxPlayoffsFormatted: any = roundTitles.map((item) => {
        return { title: item, seeds: [] };
      });
      roundTitles.forEach((title) => {
        const row = xboxPlayoffs[title];
        const formattedRows = row.map((item: any) => {
          const teams = [{ name: item.team1 }, { name: item.team2 || "" }];
          const roundName = item.roundName;
          return { teams, roundName };
        });
        const index = xboxPlayoffsFormatted.findIndex(
          (item: { title: string }) => item.title === title
        );
        xboxPlayoffsFormatted[index].seeds = formattedRows
        // xboxPlayoffsFormatted[title].seeds.push(row)
      });
      return xboxPlayoffsFormatted;
    }
  };

  const xboxPlayoffsData: RoundProps[] = getXboxPlayoffData()
  const playstationPlayoffData: RoundProps[] = getPlaystationPlayoffData()

  const CustomSeed = ({
    seed,
    breakpoint,
    roundIndex,
    seedIndex,
  }: RenderSeedProps) => {
    // breakpoint passed to Bracket component
    // to check if mobile view is triggered or not

    // mobileBreakpoint is required to be passed down to a seed
    return (
      <Seed mobileBreakpoint={breakpoint} style={{ fontSize: 12 }}>
        <SeedItem>
          <div>
            {seed.roundName}
            {seed.teams[0]?.name ? (
              <SeedTeam>{seed.teams[0]?.name || "NO TEAM "}</SeedTeam>
            ) : null}
            {seed.teams[1]?.name ? (
              <SeedTeam>{seed.teams[1]?.name || "NO TEAM "}</SeedTeam>
            ) : null}
          </div>
        </SeedItem>
      </Seed>
    );
  };

  const xboxBracket = xboxPlayoffsData ? <Bracket rounds={xboxPlayoffsData} renderSeedComponent={CustomSeed} /> : null
  const playstationBracket = playstationPlayoffData ? <Bracket rounds={playstationPlayoffData} renderSeedComponent={CustomSeed} /> : null

  return (
    <div className="container scheduleContainer">
      <Header title="Playoffs" />
      <h2>Xbox Playoffs</h2>
      {xboxBracket}
      <h2>Playstation Playoffs</h2>
      {playstationBracket}
    </div>
  );
};
